'use strict';
angular.module('mean.databases').controller('DatabaseInventoryInvoice',
    ['$scope', '$stateParams', 'Global', 'MeanUser', 'userService',
        'builderService', 'ngDialog', 'toaster', '$filter', 'contactService',
        'Trades', 'Builders', 'Projects', 'ProjectHours', 'aceUtils', 'Users',
        'Materials', 'taskListService', 'tradeCodeService', 'Equipments', '$q',
        '$timeout', 'foremanPhaseService', '$http', 'Inventory', '$state',
        function ($scope, $stateParams, Global, MeanUser, userService, builderService,
            ngDialog, toaster, $filter, contactService, Trades, Builders, Projects, ProjectHours,
            aceUtils, Users, Materials, taskListService, tradeCodeService, Equipments, $q, $timeout, foremanPhaseService, $http, Inventory, $state) {
            $scope.global = Global;
            $scope.package = {
                name: 'contacts'
            };
            console.log('DatabaseInventoryInvoice');
            $scope.minDateMoment = moment();
            $scope.user = MeanUser.user;
            $scope.tradeAccountId = '';
            $scope.deliveryDate = moment().format('YYYY-MM-DD');
            $scope.dateFormat = 'MMM D, YYYY : HH:mm';
            $scope.emailTo = $scope.categories = $scope.materials = $scope.materialCart = [];
            $scope.addMaterialInput = { category: 'all', material: '', notes: '', quantity: '', delivery_price: 0 };
            $scope.pdfHeadings = {
                name: 'Name', notes: 'Notes', quantity: 'Quantity', bulkQuantity: 'Bulk Quantity', bulkPrice: 'Bulk Price',
                totalQuantity: 'Total Quantity', subTotal: 'Sub Total', delivery_price: ' Delivery Price'
            };
            $scope.init = function () {
                $scope.supplierName = decodeURI($stateParams.supplier);
                userService.getMainAccount($scope.user.username).then((user) => {
                    $scope.main_account = user;
                    Trades.query({ 'main_account_id': user._id }, (trade) => {
                        $scope.company = trade[0];
                        $scope.tradeAccountId = trade[0]._id
                        $scope.getEmails();
                    });
                });
            }

            $scope.editSwitchInput = '';
            $scope.cartTotals = {
                subtotal: 0.00,
                taxes: 0.00,
                delivery: 0.00,
                total: 0.00
            };
            $scope.just_print = false;

            $scope.getEmails = () => {
                ($scope.company.company_emails && $scope.company.company_emails.length) && ($scope.emailTo = [...$scope.emailTo, ...$scope.company.company_emails]);
                if ($scope.company.inventory_suppliers && $scope.company.inventory_suppliers.length) {
                    $scope.company.inventory_suppliers.forEach(sup => {
                        (sup.emails && sup.emails.length) && ($scope.emailTo = [...$scope.emailTo, ...sup.emails]);
                    });
                }
            }

            /**
             * @description Open the popup model for adding the material
             */
            $scope.addMaterial = () => {
                console.log($scope.supplierName);
                $scope.getMaterial();
                $scope.getCategories();
                ngDialog.openConfirm({
                    template: 'databases/views/tmpl/add-material-inventory-invoice.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding',
                    closeByDocument: false,
                    closeByEscape: false,
                }).then((value) => {
                    if ($scope.materialCart.filter(item => item.material._id == $scope.addMaterialInput.material._id).length) {
                        toaster.pop('error', 'Material already in list');
                        return;
                    }
                    $scope.materialCart.push(JSON.parse(JSON.stringify($scope.addMaterialInput)));
                    $scope.updateCartMaterials();
                    $scope.resetAddMaterialForm();
                }, (value) => {
                    $scope.resetAddMaterialForm();
                });
            };
            /**
             * @description select the delivery date popup on submit button click
             */
            $scope.selectDelivery = () => {
                ngDialog.openConfirm({
                    template: 'databases/views/tmpl/material-delivery-date-popup.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-sm ',
                    closeByDocument: false,
                    closeByEscape: false,
                }).then((value) => {
                    $scope.deliveryDate = value;
                    $scope.deliveryDate && $scope.submitInvoice();
                }, (value) => {
                    $scope.deliveryDate = moment().format('YYYY-MM-DD');
                });
            };

            $scope.submitInvoice = () => {
                var inventory = [];
                $scope.materialCart.forEach((item, indexNo) => {
                    var tempInventory = new Inventory({
                        supplier: $scope.supplierName,
                        category: item.material.category,
                        quantity: item.quantity,
                        quantityLeft: (item.quantity * item.material.bulkQuantity),
                        invoiceNumber: 'INVE-' + $scope.user.username + '-' + indexNo,
                        dateDelivered: moment($scope.deliveryDate),
                        runOutDate: moment(),
                        trade_code: item.material.trade,
                        company_code: $scope.company.company_code,
                        userId: $scope.main_account._id,
                        totalCartAmount: $scope.cartTotals.total,
                        material: {
                            material_id: item.material._id,
                            name: item.material.name,
                            trade: item.material.trade,
                            supplier: item.material.supplier,
                            category: item.material.category,
                            bulkPrice: item.material.bulkPrice,
                            bulkQuantity: item.material.bulkQuantity,
                            piece_per_size: item.material.piece_per_size,
                            delivery_price: item.material.delivery_price,
                            price_per_order: item.material.price_per_order,
                            units_per_order: item.material.units_per_order
                        }
                    })
                    inventory.push(tempInventory);
                });

                Inventory.bulkAdd(inventory, function (results) {
                    $scope.buildPDF();
                    toaster.pop('success', 'Inventory  added successfully.');
                    $state.go('databases');
                })
            };

            /**
             * @description reset the add material form
             */
            $scope.resetAddMaterialForm = () => {
                $scope.addMaterialInput = { category: 'all', material: '', notes: '', quantity: '', delivery_price: 0 };
            }

            /**
             * @description getting the all categories related to selected supplier
             */
            $scope.getCategories = () => {
                Materials.query({
                    type: 'InvoiceCreate',
                    supplier: $scope.supplierName,
                    trade_account: $scope.tradeAccountId,
                    userId: $scope.main_account._id
                 }, (categories) => {
                    $scope.categories = categories.sort();
                });
            }

            /**
             * @description getting the materials list on selection of category
             */
            $scope.getMaterial = () => {
                Materials.query({
                    type: 'InvoiceCreateMaterials',
                    category: 'all', // $scope.addMaterialInput.category,
                    supplier: $scope.supplierName,
                    trade_account: $scope.tradeAccountId,
                    userId: $scope.main_account._id
                 }, (materials) => {
                    $scope.materials = materials;
                });
            }

            $scope.editOn = function (indexNo, inputField) {
                $scope.editSwitchInput = inputField;
            }

            $scope.onChange = function (indexNo, inputField, values) {
                $scope.materialCart[indexNo][inputField] = values || 0;
                $scope.updateCartMaterials();
            }

            $scope.editOff = function () {
                this.editSwitchInput = '';
            }

            $scope.back = function () {
                $state.go('databases');
            };

            $scope.resetTotals = function () {
                $scope.cartTotals = { subtotal: 0.00, taxes: 0.00, delivery: 0.00, total: 0.00 }
            }

            $scope.updateCartMaterials = function () {
                $scope.resetTotals();
                $scope.materialCart.forEach(item => {
                    var saleTax = ($scope.company.costs.sales_tax * item.quantity * item.material.bulkQuantity * item.material.bulkPrice);
                    $scope.cartTotals.subtotal += (item.quantity * item.material.bulkQuantity * item.material.bulkPrice) || 0;
                    $scope.cartTotals.taxes += (saleTax || 0);
                    $scope.cartTotals.delivery += item.delivery_price;
                    $scope.cartTotals.total += ($scope.cartTotals.subtotal + $scope.cartTotals.taxes + $scope.cartTotals.delivery);
                });
            }

            $scope.table = function (data, columns) {
                return [{
                    table: {
                        headerRows: 1,
                        widths: [60, 60, 60, 60, 60, 60, 60, 60],
                        body: $scope.buildTableBody(data, columns)
                    },
                    fontSize: 10
                }];
            };

            $scope.buildTableBody = function (data, columns) {
                var body = [];
                body.push(columns.map(e => $scope.pdfHeadings[e]));

                _.each(data, function (row) {
                    var dataRow = [];

                    _.each(columns, function (column) {
                        if (column === 'name') {
                            dataRow.push(row['material'][column]);
                        } else if (column === 'bulkQuantity') {
                            dataRow.push(row['material'][column]);
                        } else if (column === 'bulkPrice') {
                            dataRow.push('$ ' + row['material'][column].toFixed(2).toString());
                        } else if (column === 'totalQuantity') {
                            dataRow.push((row['quantity'] * row['material']['bulkQuantity']).toString());
                        } else if (column === 'subTotal') {
                            dataRow.push('$ ' + (row['quantity'] * row['material']['bulkPrice']).toFixed(2));
                        } else if (column === 'delivery_price') {
                            dataRow.push('$ ' + (row['delivery_price']).toFixed(2));
                        } else {
                            dataRow.push(row[column]);
                        }
                    })

                    body.push(dataRow);
                });

                return body;
            };

            $scope.buildPDF = function () {

                var list_title = 'Inventory Materials List';
                // var po_num = $scope.company.company_code;

                var test = {
                    pageMargins: [10, 70, 10, 20],
                    pageSize: 'A4',
                    Roboto: {
                        normal: 'Roboto-Regular.ttf',
                        bold: 'Roboto-Medium.ttf',
                        italics: 'Roboto-Italic.ttf',
                        bolditalics: 'Roboto-Italic.ttf'
                    },
                    header: [

                        {
                            canvas: [{
                                type: 'line',
                                x1: 10,
                                y1: 10,
                                x2: 595 - 10,
                                y2: 10,
                                lineWidth: 0.5
                            }]
                        },
                        {
                            fontSize: 8,
                            columns: [{
                                text: 'A.C.E. Construction Software',
                                margin: [10, 0, 0, 0],
                                width: 100
                            }]
                        },
                        {
                            fontSize: 8,
                            columns: [{
                                text: 'Inventory Report',
                                margin: [10, 0, 0, 0],
                                width: 100
                            }]
                        },
                        {
                            canvas: [{
                                type: 'line',
                                x1: 10,
                                y1: 0,
                                x2: 595 - 10,
                                y2: 0,
                                lineWidth: 0.5
                            }]
                        }
                    ],
                    content: [
                        {
                            fontSize: 10,
                            columns: [
                                [
                                    { text: 'Job Details ', bold: true },
                                    ' ',
                                    'Builder:                  ' + $scope.company.name,
                                    'Builder Number:   ' + $scope.company.company_code,
                                    'Job:                        Inventory',
                                    'Job Code:              INVE',
                                    'Phase:                    NA',
                                    'Lots:                       NA',
                                    'Task:                       NA',
                                    'PO Number:           NA',
                                    'Task Start Date:    NA',
                                    'Delivery Date:        ' + moment($scope.deliveryDate).format('MMM D, YYYY : HH:mm'),
                                    'Address:                ' + $scope.company.inventoryContactAddress,
                                ]
                                ,
                                [
                                    { text: 'Company Details ', bold: true },
                                    ' ',
                                    'Company Name:                 ' + $scope.company.name,
                                    'Company Number:              ' + $scope.company.phone,
                                    'Contact Person:                   ' + $scope.company.inventoryContactPerson,
                                    'Contact Phone Number:     ' + $scope.company.inventoryContactPhone,
                                    'Supplier Name:                    Inventory',
                                    'Email:                     ' + $scope.emailTo.join(',\n\t\t')
                                ]
                            ],
                            columnGap: 10
                        },
                        ' ',
                        {
                            alignment: 'center',
                            fontSize: 10,
                            text: list_title, style: 'header'
                        },
                        $scope.table($scope.materialCart, ['name', 'notes', 'quantity', 'bulkQuantity', 'bulkPrice', 'totalQuantity', 'subTotal', 'delivery_price']),
                        ' ',
                        ' ',
                        {
                            fontSize: 10,
                            columns: [
                                [

                                ]
                                ,
                                [
                                    (!$scope.is_foreman) ? 'Subtotal:       $ ' + $scope.cartTotals.subtotal.toFixed(2) : '0.00',
                                    (!$scope.is_foreman) ? 'Taxes:           $ ' + $scope.cartTotals.taxes.toFixed(2) : '0.00',
                                    (!$scope.is_foreman) ? 'Delivery:        $ ' + $scope.cartTotals.delivery.toFixed(2) : '0.00',
                                    (!$scope.is_foreman) ? 'Total:             $ ' + $scope.cartTotals.total.toFixed(2) : '0.00'
                                ]
                            ],
                            columnGap: 8
                        }
                    ],
                    defaultStyle: {
                        font: 'Roboto'
                    }
                }

                var devDate = new moment($scope.deliveryDate.delivery_date).format('MMM D, YYYY : HH:mm')

                var fileName = $scope.company.name + '-' + $scope.company.company_code + '-InventoryReport.pdf';

                if ($scope.just_print) {
                    pdfMake.createPdf(test).open();
                    $scope.just_print = false;
                } else {
                    pdfMake.createPdf(test).getBase64(function (buffer) {
                        var data = ({
                            to: $scope.emailTo,
                            subject: $scope.company.name,
                            message: 'Attached is an order from ' + $scope.company.name + '<br>' +
                                '<strong>Delivery date is scheduled for ' + devDate +
                                '</strong> <br><br>' +
                                'Delivery is to Job Address <br>' +
                                $scope.company.address_one + '<br>' +
                                $scope.company.city + ', ' + $scope.company.state + ' ' +
                                $scope.company.zip +
                                '<br><br><br>This report is created using A.C.E. Construction Software.<br>' +
                                'Please do not reply to this email and contact the contractor if you have any questions.',
                            fileName: fileName,
                            attachment: buffer
                        });

                        $http.post('/api/sendInventoryReports', data).
                            success(function (data, status, headers, config) {
                                console.log('Message was successfully sent');
                            }).
                            error(function (data, status, headers, config) {
                                console.log('There was an error with the message');
                            });
                    });
                }
            };
            $scope.printList = function () {
                $scope.just_print = true;
                $scope.buildPDF();
            }
        }
    ]);



// WEBPACK FOOTER //
// ./packages/custom/databases/public/controllers/create-inventory-invoice.js